import React, { useState } from 'react';
import { useAuthStore } from '../stores/useAuthStore';

const CompanySelector: React.FC = () => {
  const { userEmpresas, switchEmpresa, currentEmpresa } = useAuthStore();
  const [isSwitching, setIsSwitching] = useState(false);

  const handleCompanySelect = async (empresaId: string) => {
    if (isSwitching) return;
    setIsSwitching(true);
    try {
      console.log('🔄 CompanySelector: Switching to empresa:', empresaId);
      await switchEmpresa(empresaId);
      // Note: switchEmpresa now calls window.location.reload() so we won't reach here
    } catch (error) {
      console.error('❌ Error switching company:', error);
      alert('Error al cambiar de empresa. Por favor, intenta de nuevo.');
      setIsSwitching(false);
    }
  };

  if (!userEmpresas || userEmpresas.length <= 1) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <h2 className="text-xl font-bold mb-4">Selecciona tu Empresa</h2>
        <p className="text-gray-600 mb-6">
          Tienes acceso a múltiples empresas. Selecciona con cuál quieres trabajar:
        </p>
        
        {isSwitching && (
          <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg flex items-center space-x-2">
            <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
            <span className="text-blue-700 text-sm">Cambiando empresa...</span>
          </div>
        )}
        
        <div className="space-y-3">
          {userEmpresas.filter(ue => ue.empresa).map((userEmpresa) => {
            // Type guard: we filtered for empresas that exist
            const empresa = userEmpresa.empresa!;
            return (
            <button
              key={empresa.id}
              onClick={() => handleCompanySelect(empresa.id)}
              disabled={isSwitching}
              className={`w-full p-4 border rounded-lg text-left transition-colors ${
                isSwitching 
                  ? 'opacity-50 cursor-not-allowed' 
                  : 'hover:bg-gray-50'
              } ${
                currentEmpresa?.id === empresa.id
                  ? 'border-blue-500 bg-blue-50'
                  : 'border-gray-200'
              }`}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  {empresa.logo ? (
                    <img
                      src={empresa.logo}
                      alt={empresa.nombre}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                  ) : (
                    <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center text-white font-bold text-lg">
                      {empresa.nombre.charAt(0).toUpperCase()}
                    </div>
                  )}
                  <div>
                    <h3 className="font-medium">{empresa.nombre}</h3>
                    <p className="text-sm text-gray-500">
                      Rol: {userEmpresa.role}
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  {currentEmpresa?.id === empresa.id && (
                    <div className="text-blue-600 font-bold">✓</div>
                  )}
                </div>
              </div>
            </button>
            );
          })}
        </div>
        
        <div className="mt-6 pt-4 border-t">
          <button className="text-blue-600 hover:text-blue-800">
            + Crear Nueva Empresa
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompanySelector;
